/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Integrations_DescInputs */

const en_mk_nav_integrations_desc = /** @type {(inputs: Mk_Nav_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents, imports, exports, and AI connections.`)
};

const id_mk_nav_integrations_desc = /** @type {(inputs: Mk_Nav_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent, impor, ekspor, dan koneksi AI.`)
};

/**
* | output |
* | --- |
* | "Agents, imports, exports, and AI connections." |
*
* @param {Mk_Nav_Integrations_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_integrations_desc = /** @type {((inputs?: Mk_Nav_Integrations_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Integrations_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_integrations_desc(inputs)
	return en_mk_nav_integrations_desc(inputs)
});